export default __webpack_public_path__ + "static/media/GoodMannersAtSchool_09.62964a9f.png";